import {Dialog, DialogContent, DialogTitle} from "@mui/material";
import * as React from "react";
import {useTranslation} from "react-i18next";
import LogDetails from "crqlar-react-common/dist/components/logs/LogDetails";

interface Props {
    reservationId?: string
    open: boolean
    onClose: () => void
}

const ReservationLogsDialog: React.FC<Props> = ({
                                                    reservationId,
                                                    open,
                                                    onClose
                                                }) => {
    const {t} = useTranslation()


    return <Dialog
        open={open}
        onClose={() => {
            onClose()
        }}
        maxWidth="lg"
        fullWidth
    >
        <DialogTitle>
            {t('Logs')}
        </DialogTitle>
        <DialogContent>
            {reservationId && <LogDetails entityId={reservationId}/>}
        </DialogContent>


    </Dialog>
}

export default ReservationLogsDialog;